/**
 * @generated SignedSource<<d4717eb79cd0d39be0f115824a788890>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLine1",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLine2",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "LineOfService",
  "kind": "LinkedField",
  "name": "lineOfService",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "LegalContractLineOfService",
  "kind": "LinkedField",
  "name": "legalContractLineOfService",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveFrom",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveTo",
  "storageKey": null
},
v17 = [
  (v11/*: any*/),
  (v2/*: any*/)
],
v18 = [
  (v2/*: any*/),
  (v11/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayOrder",
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seq",
  "storageKey": null
},
v20 = [
  (v2/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "TaxonomyVersion",
    "kind": "LinkedField",
    "name": "applicableVersion",
    "plural": false,
    "selections": (v14/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FacilityLocationDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Facility",
                "kind": "LinkedField",
                "name": "facility",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityVersion",
                    "kind": "LinkedField",
                    "name": "applicableVersion",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegalContract",
                    "kind": "LinkedField",
                    "name": "legalContract",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegalContractLineOfService",
                        "kind": "LinkedField",
                        "name": "linesOfService",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ContractLinesOfServiceFragments_LinesOfService"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityIdentifier",
                    "kind": "LinkedField",
                    "name": "identifiers",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IdentifierType",
                        "kind": "LinkedField",
                        "name": "identifierType",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Location",
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LocationVersion",
                    "kind": "LinkedField",
                    "name": "applicableVersion",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationLanguage",
                "kind": "LinkedField",
                "name": "languages",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FacilityLocationLanguages_Languages"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationLineOfService",
                "kind": "LinkedField",
                "name": "linesOfService",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FacilityLocationLineOfService"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationCmsSpecialty",
                "kind": "LinkedField",
                "name": "cmsSpecialties",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FacilityLocationCmsSpecialties_CmsSpecialties"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationVersion",
                "kind": "LinkedField",
                "name": "versions",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FacilityLocationVersions_Versions"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationTaxonomy",
                "kind": "LinkedField",
                "name": "taxonomies",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FacilityLocationTaxonomies_Taxonomy"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationPracticePeriod",
                "kind": "LinkedField",
                "name": "practicePeriods",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FacilityLocationPracticePeriods_PracticePeriod"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "FacilityLocation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Language",
        "kind": "LinkedField",
        "name": "allLanguages",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllLanguagesDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CmsSpecialty",
        "kind": "LinkedField",
        "name": "allCmsSpecialties",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllCmsSpecialtiesDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Taxonomy",
        "kind": "LinkedField",
        "name": "allTaxonomies",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllTaxonomiesDropdown"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FacilityLocationDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Facility",
                "kind": "LinkedField",
                "name": "facility",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityVersion",
                    "kind": "LinkedField",
                    "name": "applicableVersion",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegalContract",
                    "kind": "LinkedField",
                    "name": "legalContract",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegalContractLineOfService",
                        "kind": "LinkedField",
                        "name": "linesOfService",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "otherServicesDiscountPercentage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "percentageOfBase",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isComplex",
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityIdentifier",
                    "kind": "LinkedField",
                    "name": "identifiers",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IdentifierType",
                        "kind": "LinkedField",
                        "name": "identifierType",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Location",
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LocationVersion",
                    "kind": "LinkedField",
                    "name": "applicableVersion",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationLanguage",
                "kind": "LinkedField",
                "name": "languages",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Language",
                    "kind": "LinkedField",
                    "name": "language",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationLineOfService",
                "kind": "LinkedField",
                "name": "linesOfService",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegalContractLineOfService",
                    "kind": "LinkedField",
                    "name": "lineOfService",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LineOfService",
                        "kind": "LinkedField",
                        "name": "lineOfService",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationCmsSpecialty",
                "kind": "LinkedField",
                "name": "cmsSpecialties",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CmsSpecialty",
                    "kind": "LinkedField",
                    "name": "cmsSpecialty",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CmsSpecialtyVersion",
                        "kind": "LinkedField",
                        "name": "applicableVersion",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberOfBeds",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationVersion",
                "kind": "LinkedField",
                "name": "versions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mondayHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tuesdayHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wednesdayHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thursdayHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fridayHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "saturdayHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sundayHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "acceptingNewPatients",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "facilityWheelchairAccessible",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requiresReferral",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appointmentWaitTime",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "showInDirectory",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "providesHomeVisits",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "providesOfficeVisits",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "providesTelehealth",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationTaxonomy",
                "kind": "LinkedField",
                "name": "taxonomies",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Taxonomy",
                    "kind": "LinkedField",
                    "name": "taxonomy",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationPracticePeriod",
                "kind": "LinkedField",
                "name": "practicePeriods",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "FacilityLocation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Language",
        "kind": "LinkedField",
        "name": "allLanguages",
        "plural": true,
        "selections": (v18/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CmsSpecialty",
        "kind": "LinkedField",
        "name": "allCmsSpecialties",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CmsSpecialtyVersion",
            "kind": "LinkedField",
            "name": "applicableVersion",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appliesToFacilities",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appliesToPractitioners",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresBedCount",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Taxonomy",
        "kind": "LinkedField",
        "name": "allTaxonomies",
        "plural": true,
        "selections": (v20/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1092f9611cc7fce8ab5a3c3a8732cf8e",
    "id": null,
    "metadata": {},
    "name": "FacilityLocationDetailsQuery",
    "operationKind": "query",
    "text": "query FacilityLocationDetailsQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    id\n    ... on FacilityLocation {\n      facility {\n        id\n        applicableVersion {\n          displayName\n          id\n        }\n        legalContract {\n          linesOfService {\n            ...ContractLinesOfServiceFragments_LinesOfService\n            id\n          }\n          id\n        }\n        identifiers {\n          identifierType {\n            code\n            id\n          }\n          value\n          id\n        }\n      }\n      location {\n        addressLine1\n        addressLine2\n        city\n        state\n        postalCode\n        applicableVersion {\n          name\n          id\n        }\n        id\n      }\n      legalContractLineOfService {\n        id\n        lineOfService {\n          id\n          name\n        }\n      }\n      languages {\n        ...FacilityLocationLanguages_Languages\n        id\n      }\n      linesOfService {\n        ...FacilityLocationLineOfService\n        id\n      }\n      cmsSpecialties {\n        ...FacilityLocationCmsSpecialties_CmsSpecialties\n        id\n      }\n      versions {\n        ...FacilityLocationVersions_Versions\n        id\n      }\n      taxonomies {\n        ...FacilityLocationTaxonomies_Taxonomy\n        id\n      }\n      practicePeriods {\n        ...FacilityLocationPracticePeriods_PracticePeriod\n        id\n      }\n    }\n  }\n  allLanguages {\n    ...Fragments_AllLanguagesDropdown\n    id\n  }\n  allCmsSpecialties {\n    ...Fragments_AllCmsSpecialtiesDropdown\n    id\n  }\n  allTaxonomies {\n    ...Fragments_AllTaxonomiesDropdown\n    id\n  }\n}\n\nfragment ContractLinesOfServiceFragments_LinesOfService on LegalContractLineOfService {\n  id\n  lineOfService {\n    id\n    name\n  }\n  otherServicesDiscountPercentage\n  percentageOfBase\n  isComplex\n  effectiveFrom\n  effectiveTo\n}\n\nfragment FacilityLocationCmsSpecialties_CmsSpecialties on FacilityLocationCmsSpecialty {\n  id\n  cmsSpecialty {\n    id\n    code\n    applicableVersion {\n      name\n      id\n    }\n  }\n  numberOfBeds\n  effectiveFrom\n  effectiveTo\n}\n\nfragment FacilityLocationLanguages_Languages on FacilityLocationLanguage {\n  id\n  language {\n    id\n    name\n    isoCode\n    displayOrder\n  }\n  seq\n  effectiveFrom\n  effectiveTo\n}\n\nfragment FacilityLocationLineOfService on FacilityLocationLineOfService {\n  id\n  lineOfService {\n    id\n    lineOfService {\n      name\n      id\n    }\n  }\n  effectiveFrom\n  effectiveTo\n}\n\nfragment FacilityLocationPracticePeriods_PracticePeriod on FacilityLocationPracticePeriod {\n  id\n  effectiveFrom\n  effectiveTo\n}\n\nfragment FacilityLocationTaxonomies_Taxonomy on FacilityLocationTaxonomy {\n  id\n  seq\n  taxonomy {\n    id\n    code\n    applicableVersion {\n      displayName\n      id\n    }\n  }\n  effectiveFrom\n  effectiveTo\n}\n\nfragment FacilityLocationVersions_Versions on FacilityLocationVersion {\n  id\n  mondayHours\n  tuesdayHours\n  wednesdayHours\n  thursdayHours\n  fridayHours\n  saturdayHours\n  sundayHours\n  acceptingNewPatients\n  facilityWheelchairAccessible\n  requiresReferral\n  appointmentWaitTime\n  effectiveFrom\n  effectiveTo\n  showInDirectory\n  providesHomeVisits\n  providesOfficeVisits\n  providesTelehealth\n}\n\nfragment Fragments_AllCmsSpecialtiesDropdown on CmsSpecialty {\n  id\n  code\n  applicableVersion {\n    name\n    appliesToFacilities\n    appliesToPractitioners\n    requiresBedCount\n    id\n  }\n}\n\nfragment Fragments_AllLanguagesDropdown on Language {\n  id\n  name\n  isoCode\n  displayOrder\n}\n\nfragment Fragments_AllTaxonomiesDropdown on Taxonomy {\n  id\n  code\n  applicableVersion {\n    displayName\n    id\n  }\n}\n"
  }
};
})();

node.hash = "6cb182e081a101283064aca595737d03";

export default node;
